// @ts-nocheck

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useMsal } from "@azure/msal-react";
import { logoutRequest } from "../authConfig";
import { db } from "../db/db";
import { useEffect, useRef, useState } from "react";
// import posthog from "posthog-js";

export const Route = createFileRoute("/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  const [debugState, setDebugState] = useState("false");
  const dialogRef = useRef<HTMLDialogElement | null>(null);

  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const logout = () => {
    // Clear local app data
    localStorage.clear();
    // posthog.reset();
    db.visits.clear();
    db.clients.clear();

    // Attempt MSAL logout (will redirect to postLogoutRedirectUri)
    instance
      .logoutRedirect({
        ...logoutRequest,
        account: accounts && accounts.length > 0 ? accounts[0] : undefined,
      })
      .catch((e) => {
        console.error("MSAL logout error", e);
        // Fallback: navigate to root and force reload
        navigate({ to: "/", reloadDocument: true });
      });
  };
  const clearDB = () => {
    db.delete();
    localStorage.clear();
    navigate({ to: "/", reloadDocument: true });
  };
  const toggleDebug = () => {
    const state = JSON.stringify(!debugState);
    localStorage.setItem("debugMode", state);
    setDebugState(JSON.parse(state));
  };

  useEffect(() => {
    if (localStorage.getItem("debugMode")) {
      const mode = localStorage.getItem("debugMode");
      if (mode) {
        setDebugState(JSON.parse(mode));
      }
      // if (authRaw) {
      //   const auth = JSON.parse(authRaw);
      //   const id = auth["id"];
      //   setUserID(id);
      // }z
    }
  }, [localStorage]);

  return (
    <div className="w-full">
      <div className="card w-full bg-base-100 card-lg shadow-sm my-4">
        <div className="card-body">
          <button className="btn btn-accent" onClick={() => logout()}>
            Logout
          </button>
          <button
            className="btn btn-error"
            onClick={() => dialogRef.current?.showModal()}
          >
            Clear Local Data
          </button>
          <button className="btn btn-error" onClick={() => toggleDebug()}>
            {debugState ? "Disable" : "Enable"} Debug
          </button>
        </div>
        <dialog className="modal" ref={dialogRef}>
          <div className="modal-box">
            {/* <form method="dialog" onSubmit={() => setReadyToPost(1)}> */}
            <h3 className="text-l">
              Are you sure? This will clear any attendance data that hasn't been
              synced to the server.
            </h3>

            <div className="modal-action">
              <button
                className="btn w-full btn-error"
                // disabled={!timeAndReason}
                onClick={() => {
                  dialogRef.current?.close();
                  clearDB();
                  // dbUpdate("end", endLocationForManual, 1);
                }}
              >
                Clear the data!
              </button>
            </div>

            {/* </form> */}
          </div>
        </dialog>
      </div>
      <div className="card w-full bg-base-100 card-lg shadow-sm my-4">
        <div className="card-body">
          <h2 className="card-title">Help</h2>
          <p className="text-sm">Quick guide to each part of the app.</p>

          <div className="divider my-1" />

          <h3 className="font-semibold">Visits</h3>
          <p className="text-sm">View scheduled visits and open visit details.</p>

          <h3 className="font-semibold">Clients</h3>
          <p className="text-sm">Browse client records and related information.</p>

          <h3 className="font-semibold">AdHoc</h3>
          <p className="text-sm">Create and track ad-hoc visit activity.</p>

          <h3 className="font-semibold">Chats</h3>
          <p className="text-sm">Open team chat rooms and send updates.</p>

          <h3 className="font-semibold">Visit Forms</h3>
          <p className="text-sm">Complete visit tasks, activities, issues, incidents, expenses, and body maps.</p>

          <h3 className="font-semibold">Care Plans</h3>
          <p className="text-sm">Review care plan requirements for selected clients.</p>

          <h3 className="font-semibold">Handover Notes</h3>
          <p className="text-sm">Record key notes for the next staff handover.</p>

          <h3 className="font-semibold">Risk Assessments</h3>
          <p className="text-sm">Review and monitor active client risks.</p>

          <h3 className="font-semibold">Reconcile</h3>
          <p className="text-sm">Check and reconcile local data with synced records.</p>

          <h3 className="font-semibold">Me</h3>
          <p className="text-sm">View profile-related information and personal forms.</p>

          <h3 className="font-semibold">Settings</h3>
          <p className="text-sm">Manage logout, local data reset, and debug mode.</p>
        </div>
      </div>
    </div>
  );
}
